module.exports = __webpack_public_path__ + "static/media/photostick-mobile-apple.7dfa7ba4.png";